export default __webpack_public_path__ + "static/media/sentenceswarmup_locked_crown.d75feb93.svg";